import { render, staticRenderFns } from "./ProductsListingSearch.vue?vue&type=template&id=2a1b1708&scoped=true&"
import script from "./ProductsListingSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsListingSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b1708",
  null
  
)

export default component.exports